import { z } from 'zod';

const ListApiSchema = z
	.object({
		page: z.number(),
		pageSize: z.number(),
		count: z.number(),
		sort: z.string(),
	})
	.describe('ListApi');

export function createListApiSchema<T extends z.ZodTypeAny>(itemSchema: T) {
	return ListApiSchema.extend({
		data: z.array(itemSchema),
	}).describe(itemSchema.description ?? 'ListApi');
}
